import { useState, useRef } from "react";
import { initMantenimientoDiarioFree, ITEMS_MANTENIMIENTO_DIARIO_FREE } from '../constants/freeFormConfig';
import { Inp, ChecklistSeccion, FirmaCanvas, CampoPDF, ChecklistSeccionPDF, FirmaPDF, ModalCuotaFree } from './ui/FormControls';
import { generarPdfFree, nombreArchivoPdfFree } from '../services/pdf-free';
import { useDescargaFree } from '../hooks/useDescargaFree';

export const FreeMantenimientoDiarioTab = () => {
  const [form, setForm] = useState(initMantenimientoDiarioFree());
  const [completado, setCompletado] = useState(false);
  const [pdfDoc, setPdfDoc] = useState(null);
  const printRef = useRef(null);
  const { intentarDescarga, generando, bloqueo, cerrarBloqueo } = useDescargaFree();
  const listo = form.responsable.trim() && form.firma;
  const validadoPorTexto = `Validado por: ${form.responsable || "—"} · ${new Date().toLocaleDateString("es-ES")} ${new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}`;

  const finalizar = () => intentarDescarga(async () => {
    const doc = await generarPdfFree(printRef.current);
    setPdfDoc(doc);
    setCompletado(true);
  });

  const descargar = () => pdfDoc?.save(nombreArchivoPdfFree("mantenimiento_diario", form.responsable));

  return (
    <>
      {completado ? (
        <div className="space-y-3 text-center">
          <p className="text-2xl">✅</p>
          <h3 className="font-bold text-gray-800">Checklist diario completado</h3>
          <p className="text-sm text-gray-500">{validadoPorTexto}</p>
          <button onClick={descargar} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 transition-all">Descargar PDF</button>
          <button onClick={() => setCompletado(false)} className="text-xs text-gray-400 hover:text-gray-600">← Volver al checklist</button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Inp label="Responsable *" value={form.responsable} onChange={v => setForm(f => ({ ...f, responsable: v }))} placeholder="Nombre" />
            <Inp label="Fecha" type="date" value={form.fecha} onChange={v => setForm(f => ({ ...f, fecha: v }))} />
          </div>
          <ChecklistSeccion titulo="Ítems diarios" color="bg-green-100 text-green-800" items={ITEMS_MANTENIMIENTO_DIARIO_FREE} value={form.items} onChange={items => setForm(f => ({ ...f, items }))} />
          <FirmaCanvas onChange={firma => setForm(f => ({ ...f, firma }))} />
          {form.firma && <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>}
          <button onClick={finalizar} disabled={!listo || generando} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all">
            {generando ? "Generando PDF..." : "Finalizar checklist →"}
          </button>
        </div>
      )}

      {/* Vista oculta de solo lectura, usada únicamente para generar el PDF */}
      <div ref={printRef} style={{ position: "absolute", left: "-9999px", top: 0, width: 800 }} className="bg-white p-6 space-y-4">
        <h2 className="font-bold text-gray-800 border-b pb-2">📅 Mantenimiento Instalaciones — Diario</h2>
        <div className="grid grid-cols-2 gap-3">
          <CampoPDF label="Responsable" value={form.responsable} />
          <CampoPDF label="Fecha" value={form.fecha} />
        </div>
        <ChecklistSeccionPDF titulo="Ítems diarios" color="bg-green-100 text-green-800" items={ITEMS_MANTENIMIENTO_DIARIO_FREE} value={form.items} />
        <FirmaPDF dataUrl={form.firma} />
        <p className="text-xs text-gray-500 text-center">{validadoPorTexto}</p>
      </div>

      <ModalCuotaFree bloqueo={bloqueo} onClose={cerrarBloqueo} />
    </>
  );
};
